import Signup from 'Containers/Signup';

export default Signup;
